import cx from 'classnames';
import type { ReactNode } from 'react';
import type { IconProps } from '../Icon';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
import styles from './styles.module.css';

export interface InputTagProps {
  color?: 'success' | 'danger';
  children: ReactNode;
  icon?: IconProps['name'];
}

/** @deprecated use InputTag from kitt-universal instead */
export function InputTag({ children, color, icon }: InputTagProps): ReactNode {
  return (
    <Typography.span
      base="body-small"
      className={cx(styles.InputTag, {
        [styles.Success]: color === 'success',
        [styles.Danger]: color === 'danger',
      })}
    >
      {icon ? <Icon className={styles.Icon} name={icon} /> : null}
      <span className={styles.Text}>{children}</span>
    </Typography.span>
  );
}
